<template>
  <div class="values-of-filter" v-if="filters.length" v-for="filter in filters">
    <div class="main-values">
      <span class="value-filter"
            v-for="value in filter['children']"
            :data-id="value.id"
            v-on:click="handleClickedFilters($event, value.id)">
       {{ value.name }}
        </span>
    </div><!--.main-values-->
    <span class="value-filter"
          data-id="all"
          v-on:click="handleClickedFilters($event, 'all')">
        Ver tudo
      </span>
  </div><!--.values-of-filter-->

  <div class="all-articles">
    <a v-if="articles.length"
       v-for="item in articles"
       :href="item.slug" class="each-article">

      <figure>
        <picture>
          <source media="(max-width: 767.98px)"
                  :srcset="item.featured_image.mediaCollection['thumbnail_double_width']"/>

          <source media="(max-width: 1199.98px) and (min-width: 768px)"
                  :srcset="item.featured_image.mediaCollection['thumbnail_full_width']"/>
          <source media="(min-width: 1200px)"
                  :srcset="item.featured_image.mediaCollection['thumbnail']"/>
          <img class="img-article"
               :src="item.featured_image.mediaCollection['thumbnail']"
               :alt="item.featured_image.title"/>
        </picture>
        <figcaption>
          <div class="filters-list">
            <h2 class="subtitle" v-for="filter in item.filters">{{ filter.name }} - </h2>
            <h2 class="subtitle">{{ new Date(item.created_at).toLocaleDateString('pt-PT') }}</h2>
          </div>
          <h1 class="title">{{ item.title }}</h1>
        </figcaption>
      </figure>
    </a>
    <p v-if="!articles.length" class="subtitle">Sem artigos</p>
  </div><!--.all-articles-->

  <div class="pagination" v-if="pagination['next_page_url']">
    <ul>
      <li v-if="pagination['prev_page_url']" class="prev-page">
        <a :href="pagination['prev_page_url']">Anterior</a>
      </li>
      <li class="current-page">
        <span>{{ pagination['current_page'] }}</span>
      </li>
      <li v-if="pagination['next_page_url']" class="next-page">
        <a :href="pagination['next_page_url']">Seguinte</a>
      </li>
    </ul>
  </div>

</template>
<script>


export default {
  data: () => ({
    category: [],
    filters: [],
    articles: [],
    pagination: [],
    xhrLoadDataEventFn: null,
  }),

  mounted() {
    const ownElem = this;

    window.addEventListener('load', function (event) {
      ownElem.category = window.data;
      ownElem.filters = window.data.filters;

      ownElem.articles = window.data.paginatedArticles['articles'];
      ownElem.pagination = window.data.paginatedArticles['paginator'];
      console.log(ownElem.pagination);
    });

    const url = new URL(window.location);

    this.selected_family = url.searchParams.get('category') ?? this.category.id;
    this.selected_family = url.searchParams.get('filter') ?? 'all';

  },

  methods: {
    handleClickedFilters(evt, id) {
      let element = evt.target;

      const url = new URL(window.location);
      url.searchParams.set('category', this.category.id);
      url.searchParams.set('filter', id);

      window.history.pushState({}, '', url);

      if (this.xhrLoadDataEventFn != null) {
        clearTimeout(this.xhrLoadDataEventFn);
      }
      this.xhrLoadDataEventFn = setTimeout(() => {
        const xhr = new window.fetchdata();
        const fullUrl = `${baseUrl}/ajaxservice/get-articles-by-filter?category=${this.category.id}&filter=${id}`;
        xhr.fetchData(
          fullUrl,
          'GET',
          undefined,
          (result) => {
            console.log(result);
            this.articles = [];
            this.pagination = [];

            this.articles = result.articles;
            this.pagination = result.paginator;

            Array.from(document.querySelectorAll('span.value-filter')).forEach(function (el) {
              el.classList.remove('active');
            });

            if (element.getAttribute("data-id") !== 'all') {
              element.classList.add('active');
            }
          },
          (result) => {
            console.error(result);
          }
        );
      }, 300)
    }
  }
}
</script>
